<template>
  <div class="contact">
    <header class="page-header">
      <h1>Contact Plan Administrator</h1>
      <p>Please do not send sensitive or confidential data through this messaging system.</p>
    </header>
    <br-card>
      <h2 class="uk-margin-medium-bottom">
        Send us a message
      </h2>
      <input-field
        :value="subject"
        :use-wide="true"
        @input="evtChangeSubject"
      >
        Subject
      </input-field>
      <text-field
        :value="message"
        :use-wide="true"
        @input="evtChangeMessage"
      >
        Message
      </text-field>
      <standard-button
        class="uk-float-right"
        @click="submitForm"
      >
        Send
      </standard-button>
      <span class="uk-clearfix" />
      <va-modal
        v-if="showThanksMessage"
        v-model="showThanksMessage"
        title="Thank you for contacting us!"
        close-button
      >
        <p>{{ thanksResponse }}</p>
      </va-modal>
      <va-modal
        v-if="showFailMessage"
        v-model="showFailMessage"
        title="Something Went Wrong"
        close-button
      >
        <p>Something went wrong with sending your message. Please try again later.</p>
      </va-modal>
      <va-modal
        v-if="showIncompleteMessage"
        v-model="showIncompleteMessage"
        title="Message Incomplete"
        close-button
      >
        <p>Please provide both a subject and a message.</p>
      </va-modal>
    </br-card>
  </div>
</template>

<script>
import BrCard from "@/components/elements/BrCard";
import InputField from "@/components/elements/InputField";
import TextField from "@/components/elements/TextField";
import StandardButton from "@/components/elements/StandardButton";
export default {
	name: "BrContact",
	components:{
		BrCard,
		InputField,
		TextField,
		StandardButton
	},
	data() {
		return {
			fullName:"",
			email:"",
			subject:"",
			message:"",
			showThanksMessage:false,
			showFailMessage: false,
			showIncompleteMessage: false,
			thanksResponse: "Your message has been sent to the plan success manager. We will get back to you within 4-5 business days."
		}
	},
	mounted() {
		this.init();
	},
	methods: {
		init(){
			this.fullName = this.$dataDirectory.userData.firstName + " " + this.$dataDirectory.userData.lastName;
			this.email = this.$dataDirectory.userData.email
		},
		submitForm(){
			if(this.subject.length > 0 && this.message.length > 0){
				this.$apiManager.post("contact", {
					fullName: this.fullName,
					email: this.email,
					subject: this.subject,
					message: this.message
				}).then(
					(pack) => this.messageSent(pack),
					() => this.messageFailed()
				)
			} else {
				this.showIncompleteMessage = true;
			}
		},
		evtChangeSubject(newValue) {
			if (typeof newValue === 'string') {
				this.subject = newValue;
			}
		},
		evtChangeMessage(newValue) {
			if (typeof newValue === 'string') {
				this.message = newValue;
			}
		},
		messageSent(pack){
			if(pack.data && pack.data.success){
				this.showThanksMessage = true;
				this.thanksResponse = pack.data.response;
				this.subject = "";
				this.message = "";
			}
		},
		messageFailed(){
			this.showFailMessage = true;
		}
	}
}
</script>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";

.page-header{
	margin-bottom: 3vw;

	h1{
		margin-bottom: 0px;
	}


	h1 + *{
		margin-top: 10px;
	}
}

.contact{
	.input-field-field{
		width: 80%;
	}
}

.uk-modal-title{
	color: variables.$color-text;
	font-family: variables.$font-primary;
}
</style>
